import { getApplicationFormValues } from "./getApplicationFormValues";

export const getChildrenCount = () => {
  const formValues = getApplicationFormValues();
  return parseInt(formValues.num_of_children_younger_than_21);
};
